module.exports = __webpack_public_path__ + "img/space.3.1d4a0ff6.webp";